// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Formality from "../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Caml_format from "../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as FormInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";
import * as SelectComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/drop-downs/SelectComponent.bs.js";
import * as PricingDashboardDataMachine from "../../../../pricing-dashboard/app/PricingDashboardDataMachine.bs.js";

function convertGeoLocationToDropDownItems(geoRegionList) {
  return List.map((function (geoRegion) {
                return {
                        key: String(geoRegion.id),
                        value: geoRegion.name,
                        text: geoRegion.name
                      };
              }), geoRegionList);
}

function getSelectedGeoRegion(selectedRegion) {
  if (selectedRegion !== undefined) {
    return {
            id: Caml_format.caml_int_of_string(selectedRegion.key),
            name: selectedRegion.text
          };
  }
  
}

function convertVehiclesToDropDownItems(vehicleList) {
  return List.map((function (vehicle) {
                return {
                        key: String(vehicle.vehicle_id),
                        value: vehicle.vehicle.vehicle_type,
                        text: vehicle.vehicle.vehicle_type
                      };
              }), vehicleList);
}

function getSelectedVehicle(selectedVehicle) {
  if (selectedVehicle !== undefined) {
    return {
            vehicle_id: Caml_format.caml_int_of_string(selectedVehicle.key),
            vehicle: {
              vehicle_type: selectedVehicle.value,
              display_name: selectedVehicle.text
            }
          };
  }
  
}

var validators_selectedVehicle = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var selectedVehicle = param.selectedVehicle;
      if (selectedVehicle !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: getSelectedVehicle(selectedVehicle)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Please select vehicle"
              };
      }
    })
};

var validators_selectedGeoregion = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var selectedGeoregion = param.selectedGeoregion;
      if (selectedGeoregion !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: getSelectedGeoRegion(selectedGeoregion)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Please select geo region"
              };
      }
    })
};

var validators = {
  selectedVehicle: validators_selectedVehicle,
  selectedGeoregion: validators_selectedGeoregion
};

function initialFieldsStatuses(_input) {
  return {
          selectedVehicle: /* Pristine */0,
          selectedGeoregion: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            selectedVehicle: /* Pristine */0,
            selectedGeoregion: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.selectedVehicle;
  var match_0 = match ? match._0 : Curry._1(validators.selectedVehicle.validate, input);
  var match$1 = fieldsStatuses.selectedGeoregion;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.selectedGeoregion.validate, input);
  var selectedVehicleResult = match_0;
  var selectedVehicleResult$1;
  if (selectedVehicleResult.TAG === /* Ok */0) {
    var selectedGeoregionResult = match_0$1;
    if (selectedGeoregionResult.TAG === /* Ok */0) {
      return {
              TAG: /* Valid */0,
              output: {
                selectedGeoregion: selectedGeoregionResult._0,
                selectedVehicle: selectedVehicleResult._0
              },
              fieldsStatuses: {
                selectedVehicle: /* Dirty */{
                  _0: selectedVehicleResult,
                  _1: /* Shown */0
                },
                selectedGeoregion: /* Dirty */{
                  _0: selectedGeoregionResult,
                  _1: /* Shown */0
                }
              },
              collectionsStatuses: undefined
            };
    }
    selectedVehicleResult$1 = selectedVehicleResult;
  } else {
    selectedVehicleResult$1 = selectedVehicleResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            selectedVehicle: /* Dirty */{
              _0: selectedVehicleResult$1,
              _1: /* Shown */0
            },
            selectedGeoregion: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurSelectedVehicleField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.selectedVehicle, validators_selectedVehicle, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  selectedVehicle: status,
                                  selectedGeoregion: init.selectedGeoregion
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurSelectedGeoregionField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.selectedGeoregion, validators_selectedGeoregion, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  selectedVehicle: init.selectedVehicle,
                                  selectedGeoregion: status
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */2 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */2,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */3,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */5);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */4);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */3 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */4 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */5 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateSelectedVehicleField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.selectedVehicle, state.submissionStatus, validators_selectedVehicle, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            selectedVehicle: status,
                                            selectedGeoregion: init.selectedGeoregion
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateSelectedGeoregionField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.selectedGeoregion, state.submissionStatus, validators_selectedGeoregion, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            selectedVehicle: init.selectedVehicle,
                                            selectedGeoregion: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */2 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                selectedVehicle: /* Pristine */0,
                                selectedGeoregion: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                selectedVehicle: /* Pristine */0,
                                selectedGeoregion: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */3 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */4 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateSelectedVehicle: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateSelectedVehicleField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateSelectedGeoregion: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateSelectedGeoregionField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurSelectedVehicle: (function (param) {
              return Curry._1(dispatch, /* BlurSelectedVehicleField */0);
            }),
          blurSelectedGeoregion: (function (param) {
              return Curry._1(dispatch, /* BlurSelectedGeoregionField */1);
            }),
          selectedVehicleResult: Formality.exposeFieldResult(state.fieldsStatuses.selectedVehicle),
          selectedGeoregionResult: Formality.exposeFieldResult(state.fieldsStatuses.selectedGeoregion),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.selectedVehicle || match.selectedGeoregion) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */2);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */3);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */4);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */4,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */5);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function AllocationDashboardHomeFilter(Props) {
  var state = Props.state;
  var dispatch = Props.dispatch;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  React.useEffect((function () {
          Curry._1(dispatch, {
                TAG: /* SetZones */11,
                zones: /* Init */0
              });
          Curry._1(dispatch, {
                TAG: /* SetClusters */12,
                clusters: /* Init */0
              });
          Curry._1(dispatch, {
                TAG: /* SetZoneClusterCamapigns */13,
                zoneClusterCampaigns: /* Init */0
              });
          var region = state.selected_geo_region;
          if (region !== undefined) {
            PricingDashboardDataMachine.fetchVehicleTypes(region.id, (function (vehicles) {
                    return Curry._1(dispatch, {
                                TAG: /* SetVehicleList */3,
                                vehicles: {
                                  TAG: /* Live */1,
                                  _0: vehicles
                                }
                              });
                  }), (function (error) {
                    return Curry._1(dispatch, {
                                TAG: /* SetVehicleList */3,
                                vehicles: {
                                  TAG: /* Error */2,
                                  _0: error
                                }
                              });
                  }), country);
          }
          
        }), [state.selected_geo_region]);
  React.useEffect((function () {
          Curry._1(dispatch, {
                TAG: /* SetZoneClusterCamapigns */13,
                zoneClusterCampaigns: /* Init */0
              });
          
        }), [state.selected_vehicle]);
  var region = state.selected_geo_region;
  var vehicle = state.selected_vehicle;
  var form = useForm({
        selectedGeoregion: region !== undefined ? Belt_List.get(convertGeoLocationToDropDownItems({
                    hd: region,
                    tl: /* [] */0
                  }), 0) : undefined,
        selectedVehicle: vehicle !== undefined ? Belt_List.get(convertVehiclesToDropDownItems({
                    hd: vehicle,
                    tl: /* [] */0
                  }), 0) : undefined
      }, (function (output, _form) {
          console.log(output);
          
        }));
  var geo_regions = state.geo_regions;
  var tmp;
  if (typeof geo_regions === "number" || geo_regions.TAG !== /* Live */1) {
    tmp = null;
  } else {
    var geo_regions$1 = geo_regions._0;
    tmp = React.createElement("div", undefined, React.createElement(FormSelectInput$Catalyst.make, {
              input_props: FormInput$Catalyst.make_props("Geo region", (function ($$event) {
                      var selectedGeoRegion = SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), convertGeoLocationToDropDownItems(geo_regions$1));
                      return Curry._2(form.updateSelectedGeoregion, (function (_input, value) {
                                    return {
                                            selectedGeoregion: value,
                                            selectedVehicle: undefined
                                          };
                                  }), (Curry._1(dispatch, {
                                        TAG: /* UpdateSelectedGeoRegion */2,
                                        selected_geo_region: getSelectedGeoRegion(selectedGeoRegion)
                                      }), selectedGeoRegion));
                    }), false, undefined, "", undefined, undefined, undefined, form.selectedGeoregionResult, undefined, "ald-filter-select", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
              select_props: {
                value: form.input.selectedGeoregion,
                items: convertGeoLocationToDropDownItems(geo_regions$1),
                isNoneRequired: false
              }
            }));
  }
  var vehicles = state.vehicles;
  var tmp$1;
  var exit = 0;
  if (typeof vehicles === "number" || vehicles.TAG !== /* Live */1) {
    exit = 1;
  } else {
    var vehicles$1 = vehicles._0;
    var match$1 = state.vehicles;
    var tmp$2;
    tmp$2 = typeof match$1 === "number" || match$1.TAG !== /* Live */1 ? true : false;
    tmp$1 = React.createElement("div", undefined, React.createElement(FormSelectInput$Catalyst.make, {
              input_props: FormInput$Catalyst.make_props("Vehicle", (function ($$event) {
                      var selectedVehicle = SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), convertVehiclesToDropDownItems(vehicles$1));
                      return Curry._2(form.updateSelectedVehicle, (function (input, value) {
                                    return {
                                            selectedGeoregion: input.selectedGeoregion,
                                            selectedVehicle: value
                                          };
                                  }), (Curry._1(dispatch, {
                                        TAG: /* UpdateSelectedVehicle */4,
                                        selected_vehicle: getSelectedVehicle(selectedVehicle)
                                      }), selectedVehicle));
                    }), tmp$2, undefined, "", undefined, undefined, undefined, form.selectedVehicleResult, undefined, "", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
              select_props: {
                value: form.input.selectedVehicle,
                items: convertVehiclesToDropDownItems(vehicles$1),
                isNoneRequired: false
              }
            }));
  }
  if (exit === 1) {
    tmp$1 = React.createElement(FormSelectInput$Catalyst.make, {
          input_props: FormInput$Catalyst.make_props("Vehicle", (function (_event) {
                  
                }), true, undefined, "", undefined, undefined, undefined, undefined, undefined, "", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
          select_props: {
            value: undefined,
            items: /* [] */0,
            isNoneRequired: false
          }
        });
  }
  return React.createElement("div", {
              className: "ald-home-page-filter-container"
            }, React.createElement("div", {
                  className: "ald-home-page-filter"
                }, tmp), React.createElement("div", {
                  className: "ald-home-page-filter"
                }, tmp$1));
}

var make = AllocationDashboardHomeFilter;

export {
  convertGeoLocationToDropDownItems ,
  getSelectedGeoRegion ,
  convertVehiclesToDropDownItems ,
  getSelectedVehicle ,
  Form ,
  make ,
  
}
/* react Not a pure module */
